import React, { useState, useEffect, useRef } from 'react';

// material ui
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
// validator
import isNumeric from 'validator/lib/isNumeric';
import useStyles from './styles';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import InfoButton from '../../../../../components/InfoButton';

function SubForm08({ id, setValue, saveValue, saveValueJump, value, kb, handleNextSub, navigationMode, handleBackSub, no_kk, isSubmitting, setKB }) {

    const nextRef = useRef(null);
    const backRef = useRef(null);

    const classes = useStyles();
    const [error, setError] = useState({});
    const [useModernContrasep, setUseModernContrasep] = useState(false);

    const [jenisKb, setJenisKb] = useState(value.info_jenis_kb || '')
    const [efekSamping, setEfekSamping] = useState(value.info_efek_samping_kb || '')
    const [infoEfekSamping, setInfoEfekSamping] = useState(value.info_jika_mengalami_efek || '')

    const pertanyaan = "Pada saat pertama kali datang ke tempat pelayanan KB untuk mendapatkan alat/obat/cara kontrasepsi terakhir, apakah Ibu atau Suami mendapatkan informasi tentang:";

    useEffect(() => {

        let normalizeValue = {
            _id: `${no_kk}${id}`,
            Pertanyaan: pertanyaan,
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            Jawaban_HDate1: "",
            Jawaban_HDate2: "",
            No_Pertanyaan: 8,
            No_KK: no_kk,
            answer: [
                {
                    _id: `${no_kk}${id}01`,
                    No_Jawaban: 1,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: jenisKb,
                    Lainnya: ""
                },
                {
                    _id: `${no_kk}${id}02`,
                    No_Jawaban: 2,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: efekSamping,
                    Lainnya: ""
                },
                {
                    _id: `${no_kk}${id}03`,
                    No_Jawaban: 3,
                    Jawaban_D1: 0,
                    Jawaban_D2: 0,
                    Jawab_D3: 0,
                    Jawab_D4: 0,
                    pilihankb: infoEfekSamping,
                    Lainnya: ""
                }
            ]

        }

        if (value._rev) {
            normalizeValue._rev = value._rev
        }

        saveValueJump(normalizeValue)

    }, [jenisKb, efekSamping, infoEfekSamping])
    
    useEffect(() => {
        setError({})

        // if ((kb["0107"].jenis_kontrasepsi !== "9") || (kb["0104"].menggunakan_kontrasepsi === "1" && kb["0105"].pernah_menggunakan_kontrasepsi === "1")) {
        // // if (kb["0103"].sedang_hamil === "1"  && kb["0104"].menggunakan_kontrasepsi === "1" && kb["0105"].pernah_menggunakan_kontrasepsi === "1"  ) {
        //     setUseModernContrasep(true);
        // } else {
        //     if (navigationMode === 'back') {
        //         handleBackSub();
        //     } else {
        //         handleNextSub()
        //     }
        // }

        /* cek kondisi untuk semua form */
        if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "2" && kb["0104"].pernah_menggunakan_kontrasepsi === "1") {
            if (kb["0106"].jenis_kontrasepsi === "9") {
                // skip

                let normalizeValue = {}
                setKB({
                    ...kb,
                    [id]: {
                        ...kb[id],
                        ["info_jenis_kb"]: undefined
                    }
                })
                if (navigationMode === 'back') {
                    handleBackSub();
                } else {
                    handleNextSub()
                    saveValueJump(normalizeValue)
                }
            } else {
                // jalan
                setUseModernContrasep(true);
            }
        } else if (kb["0102"].sedang_hamil === "1" && kb["0104"].pernah_menggunakan_kontrasepsi === "2") {

            let normalizeValue = {}
            setKB({
                ...kb,
                [id]: {
                    ...kb[id],
                    ["info_jenis_kb"]: undefined
                }
            })
            if (navigationMode === 'back') {
                handleBackSub();
            } else {
                handleNextSub()
                saveValueJump(normalizeValue)
            }
        } else {
            if (kb["0102"].sedang_hamil === "2" && kb["0103"].menggunakan_kontrasepsi === "2" && kb["0104"].pernah_menggunakan_kontrasepsi === "2") {

                let normalizeValue = {}
                setKB({
                    ...kb,
                    [id]: {
                        ...kb[id],
                        ["info_jenis_kb"]: undefined
                    }
                })
                if (navigationMode === 'back') {
                    handleBackSub();
                } else {
                    handleNextSub()
                    saveValueJump(normalizeValue)
                }


            } else {
                if (kb["0106"].jenis_kontrasepsi === "9") {
                    // skip
                    let normalizeValue = {}
                    setKB({
                        ...kb,
                        [id]: {
                            ...kb[id],
                            ["info_jenis_kb"]: undefined
                        }
                    })
                    if (navigationMode === 'back') {
                        handleBackSub();
                    } else {
                        handleNextSub()
                        saveValueJump(normalizeValue)
                    }
                } else {
                    // jalan
                    setUseModernContrasep(true);
                }

            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!useModernContrasep) {
        return null
    }
    
    const handleChange = (e) => {

        setValue(e)

        setError({
            ...error,
            [e.target.name]: ""
        })

        switch (e.target.name) {
            case 'info_jenis_kb':
            setJenisKb(e.target.value)
            break;
            case 'info_efek_samping_kb':
            setEfekSamping(e.target.value)
            break;
            case 'info_jika_mengalami_efek':
            setInfoEfekSamping(e.target.value)
            break;
            default:
                break;
        }

        // setSomethingChange(true)
    }

    const validate = () => {
        let newError = {};

        if (!value.info_jenis_kb) {
            newError.info_jenis_kb = "Wajib diisi";
        }

        if (!value.info_efek_samping_kb) {
            newError.info_efek_samping_kb = "Wajid diisi";
        }

        if (!value.info_jika_mengalami_efek) {
            newError.info_jika_mengalami_efek = "Wajib diisi";
        }


        return newError;
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        const findErrors = validate();

        const errorValues = Object.values(findErrors);

        if (errorValues.length > 0 && errorValues.some(err => err !== '')) {
            setError(findErrors);
        } else {

            let normalizeValue = {
                _id: `${no_kk}${id}`,
                Pertanyaan: pertanyaan,
                Jawaban_H1: 0,
                Jawaban_H2: 0,
                Jawaban_HDate1: "",
                Jawaban_HDate2: "",
                No_Pertanyaan: 8,
                No_KK: no_kk,
                answer: [
                    {
                        _id: `${no_kk}${id}01`,
                        No_Jawaban: 1,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: value.info_jenis_kb,
                        Lainnya: ""
                    },
                    {
                        _id: `${no_kk}${id}02`,
                        No_Jawaban: 2,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: value.info_efek_samping_kb,
                        Lainnya: ""
                    },
                    {
                        _id: `${no_kk}${id}03`,
                        No_Jawaban: 3,
                        Jawaban_D1: 0,
                        Jawaban_D2: 0,
                        Jawab_D3: 0,
                        Jawab_D4: 0,
                        pilihankb: value.info_jika_mengalami_efek,
                        Lainnya: ""
                    }
                ]

            }
            if (value._rev) {
                normalizeValue._rev = value._rev
            }
            saveValue(normalizeValue)
        }
    }
    return (
    <>
    <form id={id} onSubmit={handleSubmit} noValidate>
        <div className={classes.card}>
            <div className={classes.cardHeader}>
                <Typography margin="normal" paragraph>
                    <span className={classes.badge}>08</span>Pada saat pertama kali datang ke tempat pelayanan KB untuk mendapatkan alat/obat/cara kontrasepsi terakhir, apakah Ibu atau Suami <strong>mendapatkan informasi</strong> tentang:</Typography>
                <div style={{ position: "absolute", right: "0", top: "82px" }}>
                    <InfoButton
                        content={
                            "Pada saat mendapatkan pelayanan kontrasepsi pertama kali, apakah responden mendapat informasi dari provider (dokter/bidan/petugas sesuai dengan fasyankes dimana responden dilayani) mengenai berbagai jenis alokon yang aman dan efektif bagi responden berdasarkan kondisi kesehatannya."+
                            "\n\nJenis-jenis alat/obat/cara kontrasepsi?"+
                            "\nDiisi ya, jika responden mampu menyebutkan minimal 3 dari 8 jenis alat/obat/cara KB kontrasepsi modern."+
                            "\n\nEfek samping alat/obat/cara KB Kontrasepsi yang dipakai?"+
                            "\nDiisi ya, jika responden mendapat informasi dari provider mengenai masalah yang mungkin timbul akibat penggunaan alat/obat/cara kontrasepsi tersebut. "+
                            "\nJika responden menggunakan jenis alat/obat/cara KB MAL, tanyakan apakah responden sudah mendapatkan informasi bahwa MAL tidak memiliki efek samping."+
                            "\n\nApa yang harus dilakukan apabila mengalami efek samping alat/obat/cara KB Kontrasepsi yang dipakai?"+
                            "\nDiisi ya, jika responden mendapat informasi dari provider tentang apa yang harus dilakukan untuk mengatasi masalah/efek samping yang mungkin timbul akibat penggunaan alat/obat/cara kontrasepsi tersebut. "+
                            "\nJika responden menggunakan jenis alat/obat/cara KB MAL, pertanyaan 08.2 diisi “Ya” maka pertanyaan 08.3 juga diisi “Ya”."
                        }
                    />
                </div>
            </div>
            <div className={classes.cardBody}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography>Jenis-jenis alat/obat/cara kontrasepsi?</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={error.info_jenis_kb ? true : false} component="fieldset">
                            <RadioGroup value={value.info_jenis_kb || ''}
                                onChange={handleChange}
                                aria-label="info_jenis_kb" name="info_jenis_kb" row>
                                <FormControlLabel control={<Radio />}
                                    value="1"
                                    label="1. Ya"
                                    labelPlacement="end"
                                />
                                <FormControlLabel control={<Radio />}
                                    value="2"
                                    label="2. Tidak"
                                    labelPlacement="end"
                                />
                            </RadioGroup>
                            <FormHelperText>{error.info_jenis_kb}</FormHelperText>
                        </FormControl>

                    </Grid>

                    <Grid item xs={12}>
                        <Typography>Efek samping alat/obat/cara kontrasepsi yang dipakai?</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={error.info_efek_samping_kb ? true : false} component="fieldset">
                            <RadioGroup value={value.info_efek_samping_kb || ''}
                                onChange={handleChange}
                                aria-label="info_efek_samping_kb" name="info_efek_samping_kb" row>
                                <FormControlLabel control={<Radio />}
                                    value="1"
                                    label="1. Ya"
                                    labelPlacement="end"
                                />
                                <FormControlLabel control={<Radio />}
                                    value="2"
                                    label="2. Tidak"
                                    labelPlacement="end"
                                />
                            </RadioGroup>
                            <FormHelperText>{error.info_efek_samping_kb}</FormHelperText>
                        </FormControl>

                    </Grid>
                    <Grid item xs={12}>
                        <Typography>Apa yang harus dilakukan apabila mengalami efek samping alat/obat/cara kontrasepsi yang dipakai?</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={error.info_jika_mengalami_efek ? true : false} component="fieldset">
                            <RadioGroup value={value.info_jika_mengalami_efek || ''}
                                onChange={handleChange}
                                aria-label="info_jika_mengalami_efek" name="info_jika_mengalami_efek" row>
                                <FormControlLabel control={<Radio />}
                                    value="1"
                                    label="1. Ya"
                                    labelPlacement="end"
                                />
                                <FormControlLabel control={<Radio />}
                                    value="2"
                                    label="2. Tidak"
                                    labelPlacement="end"
                                />
                            </RadioGroup>
                            <FormHelperText>{error.info_jika_mengalami_efek}</FormHelperText>
                        </FormControl>

                    </Grid>


                </Grid>
            </div>
        </div>
    </form>

    <Grid item xs style={{marginTop:20}}>
        <Button
            ref={backRef}
            // disabled={!isSomethingChange || isSubmitting}
            onClick={handleBackSub}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>

        {isSubmitting && <CircularProgress size={14} />}
        <Button
            style={{float: 'right'}}
            ref={nextRef}
            form={id}
            disabled={isSubmitting}
            type="submit">Selanjutnya <ChevronRight className={classes.iconRight} /></Button>
    </Grid>
    </>
    )
}

export default SubForm08;